import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedDoNotDisturb = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.1068 25.9792H33.8984V22.0208H14.1068V25.9792ZM24.0026 43.7917C21.2648 43.7917 18.6918 43.2721 16.2839 42.2331C13.8759 41.194 11.7813 39.7839 10 38.0026C8.21875 36.2214 6.80859 34.1267 5.76953 31.7187C4.73047 29.3108 4.21094 26.7378 4.21094 24C4.21094 21.2621 4.73047 18.6892 5.76953 16.2812C6.80859 13.8733 8.21875 11.7786 10 9.99739C11.7813 8.21614 13.8759 6.80598 16.2839 5.76692C18.6918 4.72786 21.2648 4.20833 24.0026 4.20833C26.7405 4.20833 29.3134 4.72786 31.7214 5.76692C34.1293 6.80598 36.224 8.21614 38.0052 9.99739C39.7865 11.7786 41.1966 13.8733 42.2357 16.2812C43.2747 18.6892 43.7943 21.2621 43.7943 24C43.7943 26.7378 43.2747 29.3108 42.2357 31.7187C41.1966 34.1267 39.7865 36.2214 38.0052 38.0026C36.224 39.7839 34.1293 41.194 31.7214 42.2331C29.3134 43.2721 26.7405 43.7917 24.0026 43.7917Z",
		fill: "url(#paint0_linear_7865_54055)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_7865_54055",
		x1: 4.00266,
		y1: 44.3125,
		x2: 50.6854,
		y2: 13.9687,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedDoNotDisturb;
